import { AvailableProperty } from "@idw-types/data/reference-data/axn";
import { RpServiceConfigurationProperty } from "@idw-types/data/rp-service-configuration";

export const formatRpServiceConfigurationProperties = (
    properties: Array<RpServiceConfigurationProperty>,
    availableProperties: Array<AvailableProperty & { category: string }>
) => {
    return availableProperties.map(ap => formatRpServiceConfigurationProperty(
        properties,
        ap
    ));
};

export const formatRpServiceConfigurationProperty = (
    properties: Array<RpServiceConfigurationProperty>,
    availableProperty: AvailableProperty & { category: string }
) => {
    const selectedProperty = (properties || []).find(property => property.propertyID === availableProperty.id);

    return {
        description: availableProperty.description,
        displayName: availableProperty.name,
        propertyId: selectedProperty?.id || null,
        propertyTypeId: availableProperty.id,
        shortName: availableProperty.name,
        type: availableProperty.type,
        value: selectedProperty?.value || null,
        values: availableProperty.values,
        category: availableProperty.category,
        addedToService: !!selectedProperty
    };
};

